import { render } from "./matching-card-compact-list-header.vue?vue&type=template&id=8b0990f6&scoped=true&ts=true"
import script from "./matching-card-compact-list-header.vue?vue&type=script&lang=ts"
export * from "./matching-card-compact-list-header.vue?vue&type=script&lang=ts"

import "./matching-card-compact-list-header.vue?vue&type=style&index=0&id=8b0990f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b0990f6"]])

export default __exports__